<section class="detail-page">

  <!-- Top Navigation Bar -->
  <div class="detail-nav">
    <a class="back-link" [routerLink]="'/materials'">
      <i class="material-icons">arrow_back</i>
      <span>Back to Library</span>
    </a>

    <div class="nav-actions" *ngIf="hasEditPermission">
      <button class="action-btn edit-btn" (click)="editMaterial()" matTooltip="Edit Material" matTooltipPosition="below">
        <i class="material-icons">edit</i>
        <span>Edit</span>
      </button>
      <button class="action-btn delete-btn" (click)="confirmationDelete()" matTooltip="Delete Material" matTooltipPosition="below">
        <i class="material-icons">delete_outline</i>
        <span>Delete</span>
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <div class="detail-content">
    <div class="detail-grid">

      <!-- Left: Image Gallery -->
      <div class="gallery-section">
        <div class="main-image-container" oncontextmenu="return false">
          <div class="watermark-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
              <defs>
                <pattern id="websiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="400" height="200">
                  <text id="name1" class="svg-pattern-1-text">eduhealthcare.com</text>
                </pattern>
                <pattern class="svg-pattern-2" xlink:href="#websiteName">
                  <text id="name2" class="svg-pattern-2-text">EDU Healthcare</text>
                </pattern>
                <pattern id="combo" xlink:href="#websiteName" patternTransform="rotate(-45)">
                  <use xlink:href="#name1" />
                  <use xlink:href="#name2" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#combo)" />
            </svg>
          </div>

          <img *ngIf="largeImageToShow" class="main-image" alt="{{ itemToBeViewed?.title }}" [src]="largeImageToShow" onerror="this.src='/assets/images/no_image_available.jpeg';" />
          <img *ngIf="!largeImageToShow && itemToBeViewed?.defaultImage" class="main-image" alt="{{ itemToBeViewed?.title }}" [src]="itemToBeViewed.defaultImage" onerror="this.src='/assets/images/no_image_available.jpeg';" />

          <div *ngIf="!largeImageToShow && !itemToBeViewed?.defaultImage" class="image-placeholder">
            <i class="material-icons">description</i>
            <span>No preview available</span>
          </div>
        </div>

        <!-- Thumbnail Strip -->
        <div *ngIf="itemToBeViewed?.fileImageArray?.length > 0" class="thumbnail-strip">
          <div *ngFor="let snapshotImage of itemToBeViewed.fileImageArray; let i = index;" class="thumbnail-item" [class.active]="selectedImage === snapshotImage" (click)="changeLargeImage(snapshotImage)">
            <div class="thumb-watermark-overlay">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                <defs>
                  <pattern id="smallWebsiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="100" height="50">
                    <text id="smallName1" class="svg-pattern-1-text">eduhealthcare.com</text>
                  </pattern>
                  <pattern id="smallCombo" xlink:href="#smallWebsiteName" patternTransform="rotate(-45)">
                    <use xlink:href="#smallName1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#smallCombo)" />
              </svg>
            </div>
            <img class="thumb-img" [src]="snapshotImage" alt="thumbnail" onerror="this.src='/assets/images/no_image_available.jpeg';" />
          </div>
        </div>

        <div *ngIf="itemToBeViewed?.fileImageArray?.length < 1 && itemToBeViewed?.defaultImage" class="thumbnail-strip">
          <div class="thumbnail-item active">
            <div class="thumb-watermark-overlay">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                <defs>
                  <pattern id="singleSmallWebsiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="200" height="100">
                    <text id="singleSmallName1" class="svg-pattern-1-text" y="30" font-size="20">eduhealthcare.com</text>
                  </pattern>
                  <pattern id="singleSmallCombo" xlink:href="#singleSmallWebsiteName" patternTransform="rotate(-45)">
                    <use xlink:href="#singleSmallName1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#singleSmallCombo)" />
              </svg>
            </div>
            <img class="thumb-img" [src]="itemToBeViewed.defaultImage" alt="thumbnail" />
          </div>
        </div>
      </div>

      <!-- Right: Details -->
      <div class="details-section">
        <div class="details-card">
          <h1 class="material-title">{{ itemToBeViewed?.title }}</h1>

          <div class="meta-tags">
            <span class="meta-tag" *ngFor="let cat of itemToBeViewed?.categories ?? []">
              <i class="material-icons tag-icon">folder_open</i>
              {{ cat?.name || 'Unknown' }}
            </span>
            <span class="meta-tag sub-tag" *ngFor="let cat of itemToBeViewed?.categories ?? []" >
              <i class="material-icons tag-icon">subdirectory_arrow_right</i>
              {{ cat?.subCategory || 'N/A' }}
            </span>
          </div>

          <div class="description-block">
            <h4 class="section-label">Description</h4>
            <p class="description-text">{{ itemToBeViewed?.description }}</p>
          </div>

          <div class="detail-actions">
            @if (showDownloadBtn) {
              <button class="primary-action-btn" (click)="checkDownloadAccess()">
                <i class="material-icons">download</i>
                Download Material
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Related Materials -->
  <div class="related-section" *ngIf="allRelated?.length">
    <div class="related-header">
      <h2 class="related-title">Related Materials</h2>
      <p class="related-subtitle">Explore similar resources you might find useful</p>
    </div>

    <div class="related-grid">
      <div class="related-item" *ngFor="let relatedItem of allRelated | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItemsCount }; let i = index;">
        <material-card [item]="relatedItem" (relatedItemSelected)="newMaterialIdRecieved($event)"></material-card>
      </div>
    </div>

    <nav class="related-pagination" aria-label="Related materials pagination" *ngIf="totalItemsCount > itemsPerPage">
      <pagination-controls class="paginationController" (pageChange)="changeThePage($event)" previousLabel="Previous" nextLabel="Next"></pagination-controls>
    </nav>
  </div>

  <!-- Empty Related -->
  <div class="related-empty" *ngIf="allRelated && allRelated.length === 0">
    <i class="material-icons">library_books</i>
    <p>No related materials found at this time.</p>
  </div>
</section>
